import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dw-sidebar-tabs" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tab.id,
        class: _normalizeClass(["dw-sidebar-tabs__tab", { 'tab--active': _ctx.isTabSelected(tab) }]),
        onClick: ($event: any) => (_ctx.onSelectTab(tab))
      }, _toDisplayString(tab.name), 11, _hoisted_2))
    }), 128))
  ]))
}